import { jsx as _jsx } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/comboboxDropdown.scss';
import React from 'react';
import { Popover } from '../../Popover/Popover';
export const ComboboxDropdown = React.forwardRef(({ comboboxRef, isOpened = false, position = null, minWidth = 0, children, classNameDropdown = null, classNameList = null, multiselectable = false, onOutsideClick }, ref) => {
    if (!isOpened) {
        return null;
    }
    const dropdownClassNames = ['combobox-dropdown', classNameDropdown];
    const listClassNames = ['combobox-dropdown-list', classNameList];
    const dropdownClassName = dropdownClassNames.filter(Boolean).join(' ');
    const listClassName = listClassNames.filter(Boolean).join(' ');
    return (_jsx(Popover, { ref: ref, className: dropdownClassName, left: position === null || position === void 0 ? void 0 : position.left, top: position === null || position === void 0 ? void 0 : position.top, minWidth: minWidth, excludeRefs: [comboboxRef], onOutsideClick: onOutsideClick, children: _jsx("div", { className: listClassName, role: "listbox", "aria-multiselectable": multiselectable || undefined, "aria-label": "Options", children: children }) }));
});
